export default "/images/info.svg?e3204b161dc9af49927c30b69a070569";